import { render } from "./TipsChains.vue?vue&type=template&id=8e0a063a"
import script from "./TipsChains.vue?vue&type=script&lang=js"
export * from "./TipsChains.vue?vue&type=script&lang=js"
script.render = render

export default script